import type { CellContext } from '@tanstack/react-table';
import { styled, useTheme } from '@mui/material';
import get from 'lodash/get';
import { ProductCode, type ServiceStatusInfo } from '../../types';
import { ServiceStatus } from '../../types';
import {
  getServiceStatusColor,
  getServiceStatusText,
} from '../../utils/serviceStatus';
import { WizerConnectorStatus } from '../../hooks/useGetWizerConnectorStatus';

export const ServiceStatusCell = (
  props: CellContext<ServiceStatusInfo, ServiceStatus>
) => {
  const theme = useTheme();

  if (
    props.row.original.product.code === ProductCode.CTS_BST &&
    get(props.table.options.meta, 'wizerConnectorStatus') ===
      WizerConnectorStatus.Activated
  ) {
    return (
      <StyledCell
        color={getServiceStatusColor(ServiceStatus.Activated, theme)}
        data-testid="service-status-cell"
      >
        {getServiceStatusText(ServiceStatus.Activated)}
      </StyledCell>
    );
  }

  return (
    <StyledCell
      color={getServiceStatusColor(props.getValue(), theme)}
      data-testid="service-status-cell"
    >
      {getServiceStatusText(props.getValue())}
    </StyledCell>
  );
};

const StyledCell = styled('div')<{ color: string }>(({ color }) => ({
  color,
}));
